import React, { memo } from 'react';
import PropTypes from 'prop-types';
import Loader from '../loader.component';

const TableLoader = memo(({ columns }) => (
  <tbody>
    <tr>
      <td colSpan={columns}>
        <Loader />
      </td>
    </tr>
  </tbody>
));

TableLoader.propTypes = {
  columns: PropTypes.number.isRequired,
};

export default TableLoader;
